

import { connect } from "react-redux";
import * as InvitesActions from "../actions/invitesActions";
import * as TranslationsActions from "../actions/translationsActions";
import * as AutoCompleteActions from "../actions/autoCompleteActions";
import * as ActionCreators from "../actions/actionCreators";
import InviteComponent from "../components/invites/inviteComponent";

const mapStateToProps = state => ({
    translations: state.translations,
    locale: state.locale,
    invites: state.invites,
    alertStatus: state.alertStatus,
    modalOnDisplay: state.modalOnDisplay,
    error: state.error,
    spinnerDisplay: state.spinnerDisplay,
    inputAreaHeight: state.inputAreaHeight,
    duplicateEmails: state.duplicateEmails,
    restrictedEmails: state.restrictedEmails,
    privacyPolicyLink: state.privacyPolicyLink,
    basePath: state.basePath,
    invitesInfoReceived: state.invitesInfoReceived
  });

const mapDispatchToProps = dispatch => ({
    getTranslations: (locale, fromUpdateLocale) => {
      dispatch(TranslationsActions.getTranslations(locale, fromUpdateLocale));
    },
    updateLocale: () => {
      dispatch(TranslationsActions.updateLocale());
    },
    getUserInfo: (accountInfo, locale) => {
      dispatch(InvitesActions.getUserInfo(accountInfo, locale));
    },
    emailSubmit: (postUrl, useV3) => {
      dispatch(InvitesActions.emailSubmit(postUrl, useV3));
    },
    displayModal: name => {
      dispatch(ActionCreators.displayModal(name));
    },
    enterPush: (postUrl, useV3, event) => {
      dispatch(InvitesActions.enterPush(postUrl, useV3, event));
    },
    expandTextArea: () => {
      dispatch(InvitesActions.expandTextArea());
    },
    removeDuplicates: delayDisplayAlert => {
      dispatch(InvitesActions.removeDuplicates(delayDisplayAlert));
    },
    resendDuplicates: duplicateEmails => {
      dispatch(InvitesActions.resendDuplicates(duplicateEmails));
    },
    autoCompleteSubmit: (postUrl, useV3) => {
      dispatch(AutoCompleteActions.autoCompleteSubmit(postUrl, useV3));
    }
  });

export default connect(mapStateToProps, mapDispatchToProps)(InviteComponent);
